import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { EMPTY, from, Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

import { ApiFragment, FragmentId } from '@stylehaven/components';
import { SearchService } from '../../common/services/api/search.service';

@Injectable({ providedIn: 'root' })
export class GenericSelectionResolverService {
    constructor(
        private readonly router: Router,
        private readonly searchService: SearchService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot
    ): ApiFragment | undefined | Observable<ApiFragment | undefined> | Promise<ApiFragment | undefined> {
        const genericSelectionId: FragmentId | null = route.paramMap.get('id') as FragmentId | null;

        if (!genericSelectionId) {
            this.router.navigate(['page-not-found']);
            return;
        }

        const parentUrl = route.pathFromRoot.map(r => r.url.map(u => u.path).join('/')).join('/');

        return this.searchService.getRecord(genericSelectionId).pipe(
            take(1),
            switchMap(genericSelection =>
                genericSelection.isDeleted()
                    ? from(this.router.navigate([parentUrl, 'removed'])).pipe(switchMap(() => EMPTY))
                    : of(genericSelection)
            ),
            catchError(error => {
                console.error(`GenericSelectionResolver:: No generic selection found with id ${genericSelectionId}`);
                return from(this.router.navigate(['page-not-found'])).pipe(switchMap(() => EMPTY));
            })
        );
    }
}
